<template>
  <loader />
</template>

<script>
import isItselfLinkable from '@/utils/isItselfLinkable';
import Loader from '@/components/Loader';

export default {
  components: { Loader },
  data() {
    return {
      devicesCount: null,
    };
  },
  computed: {
    title() {
      return this.$t('LINK_A_DEVICE');
    },
  },
  methods: {
    checkDevices() {
      setTimeout(async () => {
        await Promise.allSettled([this.$store.dispatch('getDevices', false), this.$store.dispatch('getConfig', false)]);

        const { devices } = this.$store.getters;
        if (devices.length > this.devicesCount) {
          this.$router.push('/');
          return;
        }

        this.checkDevices();
      }, 1000);
    },
  },
  created() {
    const { type, code } = this.$route.query;
    if (!isItselfLinkable() && type === 'new') {
      this.$router.push({
        name: 'error',
        params: {
          message: this.$t('ERROR_CANT_LINK_PC'),
          link: '/',
          linkText: this.$t('GO_TO_MAIN_PAGE'),
        },
      });
      return;
    }
    this.$api.link({ type, code }).then(async (response) => {
      if (response.success) {
        if (response.data.link_token) {
          this.$store.commit('lt', response.data.link_token);
        }
        await Promise.allSettled([this.$store.dispatch('getDevices', false), this.$store.dispatch('getConfig'), false]);
        this.devicesCount = this.$store.getters.devices.length;
        if (response.data.profile_service) {
          this.$router.push({
            name: 'success',
            params: {
              message: this.$t('YOUR_DEVICE_BEING_LINKED'),
              link: '/',
              linkText: this.$t('GO_TO_MAIN_PAGE'),
            },
          });
          this.checkDevices();
          window.setTimeout(() => {
            window.location.href = response.data.profile_service;
          }, 1000);
        } else {
          this.$router.push({
            name: 'success',
            params: {
              message: this.$t('PC_LINK_OK'),
              link: '/my',
              linkText: this.$t('VIEW_DEVICES_PAGE'),
            },
          });
        }
      } else {
        this.$router.push({
          name: 'error',
          params: {
            message: response.errors[0].translated,
            link: '/link',
            linkText: this.$t('GO_TO_LINK_PAGE'),
          },
        });
      }
    });
  },
};
</script>
